export const EUDatasetConfig = {
  copyFromDataCollection: '/orchestrator/jobs/addCopyToEUDataset/populateData/dataflow/{:dataflowId}',
  export: '/integration/v1/executeEUDatasetExport?dataflowId={:dataflowId}'
};
